module.exports = __webpack_public_path__ + "static/media/3.d0b18779.jpg";